export const chunk = <T>(array: Array<T>, size: number): T[][] => {
    if (array.length === 0) {
        return [array];
    }
    return array.reduce((arr, item, idx) => {
        return idx % size === 0 ? [...arr, [item]] : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
    }, [] as T[][]);
};
